import './Game.scss';
import { RootState } from '../store';
import { useAppSelector } from '../redux'
import { MONSTER_CLASSES } from '../Enums/Attributes';
import SpritesheetAsset from '../Components/SpritesheetAsset';



function MonsterAvatar() {

  const gameState = useAppSelector((state: RootState) => state.game)
  const monster = MONSTER_CLASSES.find(x => x.name === gameState.monster.name);

  if (!monster) {
    return <></>;
  }

  return (
    <div className="monster-avatar">
      <SpritesheetAsset name={monster.sprite} multiplier={8} />
    </div>
  );
}

export default MonsterAvatar;
